/**
 * Cleans up a code by removing duplicated codes that occur when fast barcode readers
 * register the same code multiple times in succession.
 *
 * @param {string} code - The code to clean up.
 * @returns {string} The cleaned up code.
 *
 * @example
 * // Barcode duplicates
 * cleanup("57410001296235741000129623") // "5741000129623"
 *
 * // QR code duplicates
 * cleanup("TICKET123ENDTICKET123END") // "TICKET123END"
 *
 * // Child ID duplicates
 * cleanup("STARTABC123ENDSTARTABC123END") // "STARTABC123END"
 */
export function cleanup(scannedCode: string): string {
  const code = scannedCode.trim();
  if (code.length === 0) {
    return code;
  }

  for (
    let minLength = 3;
    minLength <= Math.floor(code.length / 2);
    minLength++
  ) {
    const regex = new RegExp(`^(.{${minLength},})\\1+$`);
    const match = code.match(regex);

    if (match) {
      return match[1];
    }
  }

  return code;
}
